import { BuildGradientStyle } from '@utils/buildGradientStyle'
import { ReactNode } from 'react'

interface ModalFooterProps {
    children: ReactNode
    gradientStyle?: BuildGradientStyle
}

export const BonusModalFooter = ({ children, gradientStyle }: ModalFooterProps) => {
    return (
        <div style={gradientStyle} className="bg-gradient-to-r text-center -m-px">
            {children}
        </div>
    )
}
